import React, { Dispatch, SetStateAction, useState } from 'react';
import {
  StyleSheet, View, Text, TouchableOpacity, ScrollView, Pressable, TextInput,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Colors from '../../../../../constants/Colors';
import isMobile from '../../../../../components/IsMobile';
import Style from '../../../../../constants/Style';

interface AssigneeDropdownProps {
  selectedAssignee: string,
  selectedAssigneeName: string,
  setSelectedAssignee: Dispatch<SetStateAction<string>>,
  setSelectedAssigneeName: Dispatch<SetStateAction<string>>,
  setAssigneeDropdownShown: Dispatch<SetStateAction<boolean>>,
  users,
  assigneeDropdownShown: boolean,
  closeOtherDropdowns: () => void,
}

type User = {
  clientId: string,
  firstName: string,
  lastName: string,
  email: string,
  ClientIdEmail: string,
}

const AssigneeDropdown = ({
  selectedAssignee, selectedAssigneeName, setSelectedAssignee, setSelectedAssigneeName,
  setAssigneeDropdownShown, users, assigneeDropdownShown, closeOtherDropdowns,
}: AssigneeDropdownProps) => {
  const [value, onChangeText] = useState<string>('');

  return <View
    style={styles.container}
    testID='assignee-field'
  >
    <View style={styles.titleContainer}>
      <Text style={styles.filterText}>{'Assignee'}</Text>
    </View>
    <>
      {assigneeDropdownShown ? <View style={[Style.dropdown, { zIndex: 2 }]}>
        <TextInput
          placeholder='Search'
          style={[{ marginStart: 8 }, !isMobile && { outlineWidth: 0 }]}
          placeholderTextColor={Colors.light.hereworksPrimaryGrey700}
          {...{ value, onChangeText }}
        />
        <TouchableOpacity
          style={{ flex: 1, alignItems: 'flex-end' }}
          onPress={() => {
            setAssigneeDropdownShown(false);
            closeOtherDropdowns();
          }}
        >
          <FontAwesome
            size={20}
            style={styles.icon}
            name={'angle-up'}
          />
        </TouchableOpacity>
      </View> : <TouchableOpacity
        style={[Style.dropdown, { zIndex: 2 }]}
        onPress={() => {
          setAssigneeDropdownShown(!assigneeDropdownShown);
          closeOtherDropdowns();
        }}
      >
        <View style={styles.header}>
          {selectedAssignee?.length > 0
            ? <Text style={[styles.chooseAssigneeText, { color: Colors.light.hereworksBlack600 }]}>
              {selectedAssigneeName}
            </Text> : <Text style={styles.chooseAssigneeText}>{'Choose assignee'}</Text>}
          <View style={styles.iconContainer}>
            <FontAwesome
              size={20}
              style={styles.icon}
              name={'angle-down'}
            />
          </View>
        </View>
      </TouchableOpacity>}
      {assigneeDropdownShown && <ScrollView
        style={styles.filterAssigneeContainer}
        nestedScrollEnabled={true}
      >
        <Pressable
          onPress={() => {
            setSelectedAssignee('');
            setAssigneeDropdownShown(false);
            closeOtherDropdowns();
          }}
          style={(state) => [
            styles.button,
            { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
          ]}
        >
          <Text style={styles.filterText}>{'ALL ASSIGNEES'}</Text>
        </Pressable>
        {users.map((user: User) => {
          const name: string = (user.firstName && user.lastName)
            ? `${user.firstName} ${user.lastName}` : user.email;
          const email: string = `${user.clientId}-${user.email}`;

          return (name.toLowerCase().includes(value.trim().toLowerCase()) || !(value?.length > 0))
            && <Pressable
              key={`assignee_${email}`}
              onPress={() => {
                setSelectedAssignee(email);
                setSelectedAssigneeName((user.firstName && user.lastName)
                  ? `${user.firstName} ${user.lastName}` : user.email);
                setAssigneeDropdownShown(false);
                closeOtherDropdowns();
              }}
              style={(state) => [
                styles.button,
                { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
                selectedAssignee === email && styles.selected,
              ]}
            >
              <Text style={styles.filterText}>{name}</Text>
            </Pressable>;
        })}
      </ScrollView>}
    </>
  </View>;
};

const styles = StyleSheet.create({
  button: {
    paddingStart: 10,
    paddingVertical: 10,
    borderRadius: 4,
    marginVertical: 4,
  },
  container: {
    marginTop: 13,
  },
  titleContainer: {
    width: 91,
    height: 36,
    justifyContent: 'center',
  },
  header: {
    flexDirection: 'row',
    flex: 2,
    alignItems: 'center',
  },
  filterText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 18,
    marginBottom: 4,
    marginEnd: 20,
    color: Colors.light.hereworksBlack600,
  },
  chooseAssigneeText: {
    color: Colors.light.hereworksPrimaryGrey800,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    marginStart: 10,
  },
  filterAssigneeContainer: {
    width: '100%',
    maxHeight: 200,
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    marginTop: 4,
  },
  selected: {
    borderColor: Colors.light.hereworksBlue400,
    borderWidth: 1,
  },
  iconContainer: {
    flex: 1,
    alignItems: 'flex-end',
  },
  icon: {
    color: Colors.light.hereworksBlue500,
    marginEnd: 12,
  },
});

export default AssigneeDropdown;
